import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {Location} from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';


@Component({
  selector: 'app-dashboard-addtreino',
  templateUrl: './dashboard-addtreino.component.html',
  styleUrls: ['./dashboard-addtreino.component.css']
})
export class DashboardAddtreinoComponent implements OnInit {
  hideLoginLoad: boolean = false;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';
  idPaciente: any = '';
  arrTreinos: any[] = [];
  idPlano: any = 0;
  DataPlano: any = '';
  NomePlano: any = '';
  tEnviado: boolean = false;
  cooldown: any = 0;
  public maskNascimento = [ /[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public maskTelefone = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/,/\d/,/\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) {}

  ngOnInit() {
      this.tmaService.eventoFS(true);
      this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
      this.idPlano = this.route.snapshot.paramMap.get('idplano');
      //fake
      // this.arrTreinos.push({Id: 1, NomeTreino: 'Treino A - Dorsal'});
      // this.arrTreinos.push({Id: 2, NomeTreino: 'Treino B - Bíceps e Tríceps'});
      // this.arrTreinos.push({Id: 3, NomeTreino: 'Treino C - Aeróbicos HIT'});

      this.carregarListaTreinos();
  }
  ngOnDestroy(){
      console.log("destroy");
      //this.tmaService.eventoFS(false);
    }

  
  addTreino() :void{

    if(this.cooldown > 3 && this.tEnviado){
      //n pode
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose:true,
        data: {textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível adicionar mais treinos / exercícios!", iconAlerta: 'warning'}
      });
    }
    else{
      const addNT = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: {iconAlerta: "", tituloAlerta: "Novo Treino", textoAlerta: 'Adicione um treino a este plano de exercícios', textoCancel: 'Cancelar', textoConfirm: "OK", nTreino: true}
      });
      addNT.afterClosed().subscribe(result =>{
        console.log(result);
        if(result !== false && result !== ''){
          //server side
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idficha : this.idPlano,
            nometreino: result
          };
          this.hideLoginLoad = false;
          this.tmaService.addNovaFichaT(customParams).subscribe((qRes) =>{
            this.hideLoginLoad = true;
            console.log(qRes);
            if(qRes['res'] == 'ok'){
            
              this.carregarListaTreinos();
            }
            else{
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose:true,
                data: {textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning'}
              });
            }
          },
          (error) =>{
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose:true,
              data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
            });
          })
          // this.arrTreinos.push({Id: 4, NomeTreino: result});
        }
      })
    }
    
  }

  carregarListaTreinos() :void{
    
    this.hideLoginLoad = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente + '&idficha=' + this.idPlano;
    this.tmaService.getListaFichas(dadosIn)
    .subscribe((qRes) =>{
      this.hideLoginLoad = true;
      console.log(qRes);
      if(qRes['res'] == 'ok'){
        this.arrTreinos = qRes['fichasExc'];
        this.NomePlano = qRes['nomeplano'];
        this.DataPlano = qRes['dataplano'];
        this.cooldown = qRes['cooldown'];
        this.tEnviado = qRes[ 'already'];
      }
      else{
        //algo errado
      }
    })
  }


  jaEnviado() :void {
    if(this.cooldown <=3){
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        width: '300px',
        data: { textoAlerta: "Este plano já foi enviado anteriormente. Caso necessite, você ainda pode inserir/editar exercícios que serão atualizados automaticamente para o aluno.", iconAlerta: 'done_outline' }
      });
    }
    else{
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        width: '300px',
        data: { textoAlerta: "Este plano já foi enviado anteriormente. Não é mais possível realizar alterações.", iconAlerta: 'warning' }
      });
    }
    
  }


  envP() :void {
    const enviarP= this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: {iconAlerta: "warning", tituloAlerta: "Atenção", textoAlerta: "Após o envio você terá até 3 dias para editar/inserir novos exercícios, depois desse prazo não será possível alterações.<br> Confirma o envio deste plano de treino? ", textoCancel: 'Não', textoConfirm: "SIM"}
    });

    enviarP.afterClosed().subscribe(result =>{
      console.log(result);
      if(result){
        //server side
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idplano : this.idPlano
        };
        this.hideLoginLoad = false;
        this.tmaService.enviarPlanoExc(customParams).subscribe((qRes) =>{
          this.hideLoginLoad = true;
          console.log(qRes);
          if(qRes['res'] == 'ok'){
            const sendSuccess = this.dialog.open(AlertaConfirmDialog, {
              //width: '250px',
              disableClose: true,
              data: { iconAlerta: "done_outline", tituloAlerta: "Enviado", textoAlerta: "O plano de exercícios foi enviado com sucesso!", textoConfirm: "OK" }
            });

            sendSuccess.afterClosed().subscribe(result => {
              this.voltar();
            });
          }
          else{
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose:true,
              data: {textoAlerta: "Ocorreu um erro ao criar este plano. Tente novamente", iconAlerta: 'warning'}
            });
          }
        },
        (error) =>{
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
          });
        })
       
        // this.router.navigate(['/dashboard/add-treino/' + this.nickPaciente + '/' + this.idPlano ]);
      }
    })


  }
  excluirP() :void{
    const excluirPlano= this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: {iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão deste plano de treino?", textoCancel: 'Não', textoConfirm: "SIM"}
    });

    excluirPlano.afterClosed().subscribe(result =>{
      console.log(result);
      if(result){
        //server side
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idficha : this.idPlano
        };
        this.hideLoginLoad = false;
        this.tmaService.excluirPlanoT(customParams).subscribe((qRes) =>{
          this.hideLoginLoad = true;
          console.log(qRes);
          if(qRes['res'] == 'ok'){
            this.voltar();
          }
          else{
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose:true,
              data: {textoAlerta: "Ocorreu um erro ao excluir este plano. Tente novamente", iconAlerta: 'warning'}
            });
          }
        },
        (error) =>{
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
          });
        })
       
        // this.router.navigate(['/dashboard/add-treino/' + this.nickPaciente + '/' + this.idPlano ]);
      }
    })
  }
  goTreino(idTreino: any) :void{
    this.router.navigate(['/dashboard/treino/' + this.idPaciente + '/' + this.idPlano + '/' + idTreino]);
  }

  goDash() :void{
    this.router.navigate(['/dashboard/home']);
  }
  
  voltar(): void{
      //this._location.back();
      if(this.tmaService.gUrlAnterior == ''){
        this.router.navigate(['/dashboard/paciente/' + this.idPaciente ]);
      }
      else{
          this.router.navigate([ this.tmaService.gUrlAnterior]);
      }
      
  }

}